"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Tabs_meta_1 = require("../Tabs.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var TabHeader =
/** @class */
function (_super) {
  __extends(TabHeader, _super);

  function TabHeader(props) {
    var _this = _super.call(this, props) || this;

    _this.assignReference = function (instance) {
      var assignTabReference = _this.props.assignTabReference;
      _this.headerRef = instance;

      if (assignTabReference) {
        return assignTabReference(instance);
      }
    };

    return _this;
  }

  TabHeader.prototype.componentDidMount = function () {
    this.setFocus();
  };

  TabHeader.prototype.componentDidUpdate = function () {
    this.setFocus();
  };

  TabHeader.prototype.setFocus = function () {
    var isFocused = this.props.isFocused;

    if (isFocused && this.headerRef) {
      this.headerRef.focus();
    }
  };

  TabHeader.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        _b = _a.children,
        children = _b === void 0 ? '' : _b,
        assignTabReference = _a.assignTabReference,
        isFocused = _a.isFocused,
        headerProps = __rest(_a, ["className", "children", "assignTabReference", "isFocused"]);

    return react_1.default.createElement("section", __assign({
      className: className
    }, headerProps, {
      ref: this.assignReference
    }), children);
  };

  return TabHeader;
}(react_1.default.Component);

exports.TabHeader = TabHeader;
exports.default = InjectedStyledComponent_1.InjectedStyledComponent(TabHeader, Tabs_meta_1.TABS_CATEGORY_KEY, Tabs_meta_1.TABS_COMPONENT_KEY, ['tabHeader']);